(() => {
  const ACCOUNT_PAGE = '/pages/account-access';
  const SECURE_ACCOUNT_URL = 'https://account.driveeasymalta.com';
  const ACCOUNT_PATHS = new Set(['/account', '/account/', '/account/login', '/account/register', '/account/recover']);
  const REGISTER_PAGE_PATHS = new Set([...ACCOUNT_PATHS, ACCOUNT_PAGE]);

  const getPath = (href) => {
    try {
      return new URL(href, window.location.origin).pathname;
    } catch (error) {
      return href || '';
    }
  };

  const isAccountPath = (href) => ACCOUNT_PATHS.has(getPath(href));

  const registerMarkup = () => `
    <section class="vc-register-page-js">
      <div class="vc-register-card">
        <p class="vc-register-kicker">VitaCore account</p>
        <h1 class="vc-register-title">Create your VitaCore account</h1>
        <p class="vc-register-copy">Register or sign in with your email. Shopify will send a secure one-time code, so you do not need a password form.</p>
        <div class="vc-register-actions">
          <a class="vc-register-btn" href="${SECURE_ACCOUNT_URL}" rel="nofollow">Create account / sign in</a>
          <a class="vc-register-link" href="/products/vitacore-knee-joint-cream">Shop VitaCore</a>
        </div>
        <p class="vc-register-note">Login and registration use the same secure Shopify account flow. Enter your email and follow the code sent to your inbox.</p>
      </div>
    </section>`;

  const rewriteAccountLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !isAccountPath(href)) return;
      link.setAttribute('href', ACCOUNT_PAGE);
      link.setAttribute('data-vitacore-account-link', 'true');
      link.setAttribute('rel', 'nofollow');
    });

    document.querySelectorAll('section[name="sign-in-with-shop-provider"], shop-login-button, .shopify-login-button').forEach((element) => {
      element.style.display = 'none';
      element.setAttribute('aria-hidden', 'true');
    });
  };

  const buildRegisterPage = () => {
    if (!REGISTER_PAGE_PATHS.has(window.location.pathname)) return;
    const main = document.querySelector('#MainContent');
    if (!main || main.dataset.vitacoreRegisterReady === 'true') return;
    main.innerHTML = registerMarkup();
    main.dataset.vitacoreRegisterReady = 'true';
    document.title = 'Create your VitaCore account';
  };

  const run = () => {
    rewriteAccountLinks();
    buildRegisterPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !isAccountPath(link.getAttribute('href'))) return;
    event.preventDefault();
    window.location.assign(ACCOUNT_PAGE);
  }, true);

  new MutationObserver(rewriteAccountLinks).observe(document.documentElement, { childList: true, subtree: true });
})();
